import { ChevronDown } from "lucide-react";
import { JsonLd } from "./JsonLd";
import { SectionHeading } from "./SectionHeading";

export const Faq = ({ items, title = "Sıkça Sorulan Sorular", lead = "Randevu, konum ve hizmetlerimiz hakkında en çok merak edilenler", id = "sss" }) => {
  const data = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  };
  return (
    <section id={id} className="section bg-white" aria-labelledby={`${id}-title`} data-testid="faq-section">
      <div className="container-wide max-w-3xl">
        <SectionHeading eyebrow="SSS" title={title} lead={lead} id={`${id}-title`} />
        <div>
          {items.map((it, i) => (
            <details key={it.q} className="faq-item group card mb-3 px-5 open:border-gold/40 open:bg-gold/5 transition-colors" data-testid={`faq-item-${i}`}>
              <summary className="flex items-center justify-between gap-4 cursor-pointer py-4 list-none">
                <h3 className="text-base font-semibold text-ink group-hover:text-emerald text-left">{it.q}</h3>
                <ChevronDown size={18} aria-hidden="true" className="shrink-0 text-muted transition-transform duration-200 group-open:rotate-180" />
              </summary>
              <p className="pb-5 text-sm text-muted leading-relaxed">{it.a}</p>
            </details>
          ))}
        </div>
        <JsonLd id="faq" data={data} />
      </div>
    </section>
  );
};
